export const lookupsActions = {
  toasts: {
    errorLookupProjectsTitle: 'Proiecte',
    errorLookupProjectsMessage: 'Căutarea a eșuat',

    errorServerLookupProjectsTitle: 'Proiecte',
    errorServerLookupProjectsMessage: 'Eroare internă la căutare proiecte',

    errorLookupObjectivesTitle: 'Obiective',
    errorLookupObjectivesMessage: 'Căutarea a eșuat',

    errorServerLookupObjectivesTitle: 'Obiective',
    errorServerLookupObjectivesMessage: 'Eroare internă la căutare obiective',

    errorLookupRolesTitle: 'Roluri',
    errorLookupRolesMessage: 'Căutarea a eșuat',

    errorServerLookupRolesTitle: 'Roluri',
    errorServerLookupRolesMessage: 'Eroare internă la căutare roluri',

    errorGetUsersTitle: 'Utilizatori',
    errorGetUsersMessage: 'Încărcarea utilizatorilor a eșuat',

    errorGetTableColumnsTitle: 'Eroare',
    errorGetTableColumnsMessage: 'Încărcarea proprietăților obiectului a eșuat',

    errorExcelDownloadFailed: 'Descărcarea fișierului Excel a eșuat',
    errorContractFieldsGetFailed: 'Încărcarea câmpurilor de contract pentru generarea fișierului Excel a eșuat'
  }
}
